import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import fr_common from '@/src/locales/fr/common.json'
import en_common from '@/src/locales/en/common.json'
import ar_common from '@/src/locales/ar/common.json'
import ms_common from '@/src/locales/ms/common.json'
import kk_common from '@/src/locales/kk/common.json'
import ru_common from '@/src/locales/ru/common.json'
import cs_common from '@/src/locales/cs/common.json'
import bg_common from '@/src/locales/bg/common.json'
import km_common from '@/src/locales/km/common.json'
import zh_common from '@/src/locales/zh/common.json'
import hr_common from '@/src/locales/hr/common.json'
import nl_common from '@/src/locales/nl/common.json'
import et_common from '@/src/locales/et/common.json'
import de_common from '@/src/locales/de/common.json'
import el_common from '@/src/locales/el/common.json'
import hu_common from '@/src/locales/hu/common.json'
import it_common from '@/src/locales/it/common.json'
import he_common from '@/src/locales/he/common.json'
import lv_common from '@/src/locales/lv/common.json'
import lt_common from '@/src/locales/lt/common.json'
import pl_common from '@/src/locales/pl/common.json'
import pt_common from '@/src/locales/pt/common.json'
import ro_common from '@/src/locales/ro/common.json'
import sr_common from '@/src/locales/sr/common.json'
import sk_common from '@/src/locales/sk/common.json'
import sl_common from '@/src/locales/sl/common.json'
import es_common from '@/src/locales/es/common.json'
import tr_common from '@/src/locales/tr/common.json'
import ko_common from '@/src/locales/ko/common.json'
import th_common from '@/src/locales/th/common.json'
import zh_tw_common from '@/src/locales/zh-tw/common.json'
import { AVAILABLE_LANGUAGES } from '@/domains/Language'

export const resources = {
  'en-GB': { common: en_common },
  'fr-FR': { common: fr_common },
  ar: { common: ar_common },
  'ms-MY': { common: ms_common },
  'kk-KZ': { common: kk_common },
  'ru-RU': { common: ru_common },
  'cs-CZ': { common: cs_common },
  'bg-BG': { common: bg_common },
  'km-KH': { common: km_common },
  'zh-CN': { common: zh_common },
  'zh-TW': { common: zh_tw_common },
  'hr-HR': { common: hr_common },
  'nl-NL': { common: nl_common },
  'et-EE': { common: et_common },
  'de-DE': { common: de_common },
  'el-GR': { common: el_common },
  'hu-HU': { common: hu_common },
  'it-IT': { common: it_common },
  'he-IL': { common: he_common },
  'lv-LV': { common: lv_common },
  'lt-LT': { common: lt_common },
  'pl-PL': { common: pl_common },
  'pt-PT': { common: pt_common },
  'ro-RO': { common: ro_common },
  'sr-SP': { common: sr_common },
  'sk-SK': { common: sk_common },
  'sl-SI': { common: sl_common },
  'es-ES': { common: es_common },
  'tr-TR': { common: tr_common },
  'ko-KR': { common: ko_common },
  'th-TH': { common: th_common },
} as const

const getSavedLanguage = (): string => {
  if (typeof window === 'undefined') {
    return 'fr-FR'
  }

  const saved = localStorage.getItem('userPreferences')
  if (saved) {
    const parsed = JSON.parse(saved)
    if (parsed.state?.languageId) {
      const language = AVAILABLE_LANGUAGES.find((lang) => lang.id === parsed.state.languageId)
      return language?.code || 'fr-FR'
    }
  }
  return 'fr-FR'
}

i18n.use(initReactI18next).init({
  resources,
  lng: getSavedLanguage(),
  fallbackLng: 'en-GB',
  supportedLngs: [
    'fr-FR',
    'en-GB',
    'ar',
    'ms-MY',
    'kk-KZ',
    'ru-RU',
    'cs-CZ',
    'bg-BG',
    'km-KH',
    'zh-CN',
    'hr-HR',
    'nl-NL',
    'et-EE',
    'de-DE',
    'el-GR',
    'hu-HU',
    'it-IT',
    'he-IL',
    'lv-LV',
    'lt-LT',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'sr-SP',
    'sk-SK',
    'sl-SI',
    'es-ES',
    'tr-TR',
    'ko-KR',
    'th-TH',
    'zh-TW',
  ],
  load: 'currentOnly',
  interpolation: {
    escapeValue: false,
  },
  defaultNS: 'common',
  react: {
    useSuspense: false,
  },
})

export default i18n
